export default {"componentDescription":"","propDescriptions":{},"classDescriptions":{},"slotDescriptions":{"actions":""}};